import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=ce387202&scoped=true"
import script from "./page-not-found.vue?vue&type=script&lang=js"
export * from "./page-not-found.vue?vue&type=script&lang=js"
import style0 from "./page-not-found.vue?vue&type=style&index=0&id=ce387202&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce387202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce387202')) {
      api.createRecord('ce387202', component.options)
    } else {
      api.reload('ce387202', component.options)
    }
    module.hot.accept("./page-not-found.vue?vue&type=template&id=ce387202&scoped=true", function () {
      api.rerender('ce387202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/errors/page-not-found.vue"
export default component.exports